module.exports = __webpack_public_path__ + "static/class-image-dbc5b56ae3072712ee114b4f256098cd.jpg";